"use client";

import { AuthErrorCodes } from "firebase/auth";
import { useEffect } from "react";

export function TenantIdMismatchHandler() {
  useEffect(() => {
    function handler(error: PromiseRejectionEvent) {
      if (error.reason.code === AuthErrorCodes.TENANT_ID_MISMATCH) {
        const url = new URL(window.location.href);
        window.location.replace(url.toString());
      }
    }
    function onUnhandledRejection(event: PromiseRejectionEvent) {
      event.preventDefault();
      handler(event);
    }
    window.addEventListener("unhandledrejection", onUnhandledRejection);
    return () => {
      window.removeEventListener("unhandledrejection", onUnhandledRejection);
    };
  }, []);
  return null;
}
